<template>
    <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
            <input type="checkbox"
                   :id="entity.id"
                   :value="entity.id"
                   @click.stop
                   @change="onChange"
                   :checked="isChecked"
            />
            <label :for="entity.id" @click.stop v-translate>Vybrat</label>
        </td>
        <td :data-th="'Příjmení jméno' | translate" class="first_data"><strong>{{ fullName }}</strong></td>
        <td :data-th="'Společnost' | translate">{{ entity.company_name }}</td>
        <td :data-th="'Operátor' | translate">
          <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
        </td>
        <td :data-th="'Město' | translate">{{ entity.address.town }}</td>
        <td :data-th="'Počet odběratelů' | translate" v-if="subscribersCount">
            <span class="dotted">
                {{ subscribersCount }}
                <span class="help_popup">{{ entity.subscribers_names }}</span>
            </span>
        </td>
        <td :data-th="'Počet odběratelů' | translate" v-else></td>
        <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
        <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
        <td class="no_padding edit">
            <div class="edit_inner">
                <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
                   @click.prevent.stop="emitDeleteEntity" v-translate>Smazat</a>
            </div>
        </td>
    </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import EntityLink from "../../common/EntityLink.vue";

export default {
		name: "BillerRow",
    components: { EntityLink },
		mixins: [rowActions],
		data() {
			return {
				moduleName: 'billers',
				detailPageRouteName: 'billerDetail',
			}
		},
    computed: {
      fullName() {
        return this.entity.surname + ' ' + this.entity.firstname
      },
      subscribersCount() {
        if (this.entity.subscribers_count > 0) {
          return this.entity.subscribers_count
        }
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/billers/BillerRow.vue